import React, { useState } from 'react'
import { Box, MenuItem, TextField, Typography } from '@mui/material'
import { BaseStatTranslation } from '../../../../api/types/character'
import { chunks } from '../../../../utils'
import { IEffect } from '../../../../api/types/effect'

interface Props {
  effect?: IEffect
  register: any
}

export const BaseStatModifiers: React.FC<Props> = ({ effect, register }) => {
  const [baseStats, setBaseStats] = useState<[string, number][]>(
    Object.entries(effect?.base_stat || {})
      .filter(s => Math.abs(s[1]) > 0.01)
      .filter(s => s[0] !== 'id')
  )

  return (
    <Box sx={{ marginBottom: '8px' }}>
      <Typography variant="button" display="block" gutterBottom>
        Modyfikatory cech
      </Typography>

      {effect?.base_stat?.id && (
        <input
          type="hidden"
          name="effect_attributes.base_stat_attributes.id"
          value={effect?.base_stat?.id}
          ref={register()}
        />
      )}

      {baseStats.length < Object.keys(BaseStatTranslation).length && (
        <Box sx={{ display: 'flex', marginBottom: '8px', marginLeft: '4px', marginRight: '4px' }}>
          <TextField
            select
            fullWidth={true}
            label="Dodaj modyfikator cechy"
            value=""
            onChange={e => {
              e.preventDefault()
              setBaseStats(prevState => {
                if (!prevState.map(s => s[0]).includes(e.target.value)) {
                  return [[e.target.value, e.target.value === 'speed' ? 0.1 : 1], ...prevState]
                }
                return [...prevState]
              })
            }}
          >
            {Object.entries(BaseStatTranslation)
              .filter(stat => !baseStats.map(s => s[0]).includes(stat[0]))
              .map(stat => (
                <MenuItem key={stat[0]} value={stat[0]}>
                  {stat[1]}
                </MenuItem>
              ))}
          </TextField>
        </Box>
      )}

      {baseStats &&
        chunks(baseStats.sort(), 4).map((group: [string, number][]) => (
          <Box key={JSON.stringify(group)} sx={{ display: 'flex', marginBottom: '8px' }}>
            {group.map(stat => (
              <TextField
                key={`effect_attributes.base_stat_attributes.${stat[0]}`}
                sx={{ marginRight: '4px', marginLeft: '4px' }}
                type={'number'}
                fullWidth={true}
                name={`effect_attributes.base_stat_attributes.${stat[0]}`}
                defaultValue={stat[1]}
                label={BaseStatTranslation[stat[0]] || stat[0]}
                variant="outlined"
                inputProps={{
                  ref: register(),
                  step: stat[0] === 'speed' ? '0.1' : '1',
                }}
                onBlur={e =>
                  setBaseStats(prevState => [
                    ...prevState.filter(s => s[0] !== stat[0]),
                    [stat[0], Number(e.target.value)],
                  ])
                }
              />
            ))}
          </Box>
        ))}
    </Box>
  )
}
